/* import __COLOCATED_TEMPLATE__ from './plan-switch-modal.hbs'; */
/* RESPONSIBLE TEAM: team-self-serve */
import templateOnlyComponent from '@ember/component/template-only';

interface Signature {
  Args: {
    model: {
      onClose: () => void;
    };
  };
}

const PlanSwitchModal = templateOnlyComponent<Signature>();
export default PlanSwitchModal;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'React::PlanSwitchModal': typeof PlanSwitchModal;
    'react/plan-switch-modal': typeof PlanSwitchModal;
  }
}
